(function () {
    'use strict';
    var controllerId = '4a_pcSedeAdd';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', 'datacontext', 'sede', 'corsoId', 'opInsert', 'province', 'paesi', 'tIndirizzi', 'aziende', fn_4a_pcSedeAdd]);

    function fn_4a_pcSedeAdd($scope, $uibModalInstance,  datacontext, sede, corsoId, opInsert, province, paesi, tIndirizzi, aziende) {
        //Localizzazione
        $scope.province = province;
        $scope.paesi = paesi;
        $scope.comuni = [];
        $scope.tIndirizzi = tIndirizzi;
        //***
        $scope.aziende = aziende;
        //***
        $scope.validCF = true;
        $scope.checkCF = checkCF;

        if (sede) {
            $scope.record = jQuery.extend({}, sede); //Clona oggetto.
            $scope.Title = 'Modifica Sede (ID: ' + $scope.record.Id + ')';
            if (typeof $scope.record.Ref_CodiceFiscale != 'undefined' && $scope.record.Ref_CodiceFiscale != null && $scope.record.Ref_CodiceFiscale.length > 0) {
                checkCF($scope.record.Ref_CodiceFiscale);
            }
            if ($scope.record.ProvinciaId > 0) {
                getComuni($scope.record.ProvinciaId);
            }
        }
        else {
            $scope.Title = 'Nuova Sede';
            $scope.record = {};
            $scope.record.Id = 0;
            $scope.record.CNDPCorsoId = corsoId;
            $scope.record.OpInsert = opInsert;
            $scope.record.Deleted = false;
            $scope.record.iVersion = 1;

            $scope.record.ComuneId = '';
            $scope.record.PaeseId = 0;
            $scope.record.TIndirizzoId = 1;
        }

        //Impostazioni per calendario dateTimePicker
        $scope.datepickers = {};
        $scope.today = function () {
            $scope.dt = new Date();
        };
        $scope.today();

        $scope.clear = function () {
            $scope.dt = null;
        };

        // Disable weekend selection
        $scope.disabled = function (date, mode) {
            //return (mode === 'day' && (date.getDay() === 0 || date.getDay() === 6));
        };

        $scope.toggleMin = function () {
            $scope.minDate = $scope.minDate ? null : new Date();
        };
        $scope.toggleMin();
        $scope.dateOptions = {
            formatYear: 'yyyy',
            formatMonth: 'MM',
            startingDay: 1
        };

        $scope.openCalendar = function ($event, iOpened) {
            console.log('openCalendar');
            $event.preventDefault();
            $event.stopPropagation();

            $scope.opened1 = false;
            if (iOpened == 1) {
                console.log('iOpened == 1');
                $scope.opened1 = true;
            }

        };

        $scope.clear = function ($event, iOpened) {
            console.log('clear');
            if (iOpened == 1) {
                $scope.record.NascData = '';
                $scope.changed = true;
            }

        };

        $scope.format = "dd/MM/yyyy";



        $scope.ok = function (isValid) {
            if (isValid) {
                var result = addItem($scope.record);
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function addItem(item) {
            return item;
        }

        //localizzazione
        $scope.change_Paesi = function () {
            if ($scope.record.PaeseId > 0) {
                $scope.record.ProvinciaId = 0;
                $scope.record.ComuneId = 0;
            }
        };

        $scope.change_Comuni = function (idprov) {
            //console.info('change_Comuni()', idprov);
            $scope.record.ComuneId = '';
            getComuni(idprov);
        };

        function getComuni(idprov) {
            //console.info('getComuni()', idprov);
            if (!idprov || idprov == 0) return $scope.comuni = [];

            if ($scope.record.ProvinciaId != idprov)
                $scope.comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return $scope.comuni = data;
            });
        }


        //Funzioni
        function checkCF(_value) {
            $scope.validCF = true;
            if (typeof _value == 'undefined') return;
            if (_value.length != 16) return;
            $scope.validCF = false;
            return datacontext.validazione_cf(_value, false).then(function (data) {
                return $scope.validCF = data;
            });
        }

    }
})();